// extracted by mini-css-extract-plugin
export default {"count":"KLeBeA","appear":"x1IbH5"};